import RCustomGuandong, * as customGuangdongRouter from './RCustomGuangdong'
import RCustomCompetition, * as customCompetitionRouter from './RCustomCompetition'

const Layout = () => import('../views/LayoutCustom.vue')

export default [
  {
    path: '/custom',
    name: 'custom',
    component: Layout,
    redirect: customCompetitionRouter.dashboardRoute,
    children: [...RCustomGuandong, ...RCustomCompetition],
  },
]

export { customGuangdongRouter, customCompetitionRouter }
